import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order } from '@shared-logic/orders';
import { User } from '@shared-logic/user/user.interface';
import { DateChecker } from '@shared-logic/utils';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { areas } from '@shared-logic/user';
import { OrderValidator, resetAllOrders } from 'src/app/shared/order';
import { OrderExchange } from '@shared-logic/orders';
import { OrderExchangeValidator } from 'src/app/shared/order-exchange';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { OBJECT_ID_VOID } from 'src/app/shared/const/options';
import { Subscription } from 'rxjs';
import { ToFixValidator } from 'src/app/shared/to-fix';


@Component({
  selector: 'dialog-elements-example-dialog',
  templateUrl: './dialog.html',
  styleUrls: ['./dialog.scss']
})

export class DialogOrderExchangeCreate implements OnInit, OnDestroy {
  hour: string = '';
  mensaje: string = 'Los datos del canje están listos para generarse';
  moreInfo: string = '';
  isConfirm: boolean = true;

  //Orders
  identificatorOrderEdit: number = -1;
  disabledButton: boolean = true;

  private user!: User; //Store of Redux.
  public orders: Order[] = [];
  isComercial: boolean = true;
  order!: OrderExchange;
  isGenerateOrderExchange: boolean = false;

  private exchangeSubscription!: Subscription;
  private userSubscription!: Subscription;

  constructor(private router: Router, private store: Store<appState>, public date: DateChecker,
    public dialogRef: MatDialogRef<DialogOrderExchangeCreate>, private toFixV: ToFixValidator, private orderV: OrderValidator, private exchangeV: OrderExchangeValidator) {
    this.hour = this.date.setHourFormat();
    this.moreInfo = '';
  }

  ngOnInit(): void {
    this.exchangeSubscription = this.store.select('exchange').subscribe(exchange => {
      this.order = exchange.generateOrder;
    })

    this.userSubscription = this.store.select('usuario').subscribe(user => {
      this.user = user;
      this.isComercial = user.area == areas.comercial;
    })
  }

  ngOnDestroy(): void {
    this.exchangeSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }

  sendOrderExchange() {
    let newOrder = JSON.parse(JSON.stringify(this.order));
    const isToPrice = !this.toFixV.orderHaveIndicators(newOrder);
    newOrder.exchange = this.exchangeV.getProformsOfExchange(newOrder.exchange, this.order?.sellerData?.codeS ?? 0, isToPrice, newOrder.price);
    newOrder.exchange.idMother = OBJECT_ID_VOID;

    this.exchangeV.saveExchange(newOrder.exchange, this.user, newOrder);
    this.router.navigate(['/' + NAVEGATION.ORDER_EXCHANGE])
    resetAllOrders(this.store);
    this.dialogRef.close();
  }

}


